import styled from 'styled-components'

export const Badge = styled.span`
  display: inline-block;
  margin-top: 4px;
  padding: 2px 8px;
  border-radius: 4px;
  background: rgba(17, 88, 80, 0.08);
  color: #115850;
  font-family: 'Lato', sans-serif;
  font-size: 11px;
  font-style: italic;
  font-weight: 600;
`
